import React from 'react'
import './login.css';

const Login = () => {
  return (
    <section className="login">Login</section>
  )
}

export default Login